import * as Yup from "yup";
import { tr } from "yup-locales";
Yup.setLocale(tr);

export const GavelLoginSheme = Yup.object().shape({
  reservationNumber: Yup.number().required(),
});
